import { UTSLocale } from "@smile2impress/attraction-constants";
import { isError, AdExternalIds } from "@smile2impress/attraction-utils";
import { ExperimentIdType, FormDataType } from "@smile2impress/lead-form";
import axios from "axios";

import { sendAnalitic } from "services/AnaliticsService";
import { prepareHSProperties } from "utils/prepareHSProperties";
import { reportToSentry } from "utils/reportToSentry";

export const getAdditionalProperties = (
    locale: UTSLocale,
    formData: FormDataType,
    experimentGroupId?: ExperimentIdType,
    referralSource?: string
) =>
    prepareHSProperties({
        locale,
        clinic: String(formData.clinicId),
        asPath: "",

        marketing: {
            hasReminderAndMarketingStatus:
                formData["reminder-and-marketing-status-checkbox"],
            hasReminderStatus: false,
            hasSpecialOffers: false,
        },

        experiment: experimentGroupId ? { experimentGroupId } : undefined,

        lead: {
            promoCode: formData.promoCode,
            treatmentType: formData.treatmentType,
        },

        tracking: {
            referralSource,
        },
    });

export const handleError = (error: unknown) => {
    if (axios.isAxiosError(error) || isError(error)) {
        reportToSentry({ error: error.message, extra: { ...error } });
    }
};

export const handleSendAnalytics = async (
    { cityName, firstName, lastName, email, phone }: FormDataType,
    locale: UTSLocale,
    externalIds?: AdExternalIds
) => {
    try {
        await sendAnalitic({
            cityTitle: cityName.toLowerCase(),
            firstName: firstName.toLowerCase(),
            lastName: lastName.toLowerCase(),
            email,
            phone,
            locale,
            externalIds,
        });
    } catch (error: unknown) {
        handleError(error);
    }
};
